import { render, staticRenderFns } from "./SearchbarAutocomplete.vue?vue&type=template&id=8178a904&scoped=true&"
import script from "./SearchbarAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SearchbarAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./SearchbarAutocomplete.vue?vue&type=style&index=0&id=8178a904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8178a904",
  null
  
)

export default component.exports